var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g2, _g3, _path38, _g4, _path39, _g5, _path40, _path41, _path42, _path43, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneShip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 161,
    viewBox: "0 0 256 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 117.333C103 120.093 103.671 122.702 104.859 125H35V113H103V117.333Z",
    fill: "url(#paint0_linear_2895_3042)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103 117.333C103 120.093 103.671 122.702 104.859 125H35V113H103V117.333Z",
    fill: "url(#paint1_linear_2895_3042)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103 113H35V102H103V113Z",
    fill: "url(#paint2_linear_2895_3042)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 113H35V102H103V113Z",
    fill: "url(#paint3_linear_2895_3042)",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103 102H58V90H103V102Z",
    fill: "url(#paint4_linear_2895_3042)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103 102H58V90H103V102Z",
    fill: "url(#paint5_linear_2895_3042)",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4473 113.231H60.2457V124.921H58.4473V113.231Z",
    fill: "url(#paint6_linear_2895_3042)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8262 113.231H83.6246V124.921H81.8262V113.231Z",
    fill: "url(#paint7_linear_2895_3042)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4473 102H60.2457V113H58.4473V102Z",
    fill: "url(#paint8_linear_2895_3042)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8262 102H83.6246V113H81.8262V102Z",
    fill: "url(#paint9_linear_2895_3042)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8262 90.0002H83.6246V102H81.8262V90.0002Z",
    fill: "url(#paint10_linear_2895_3042)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3828 113.231C48.0807 113.231 56.3673 116.937 62.167 123.419L63.5117 124.921H104.817C107.562 130.3 113.135 134 119.6 134H177.449L159.157 156.393H27.875L27.8408 156.21C27.004 151.748 24.3106 147.851 20.4326 145.49C11.0858 139.801 4.35707 130.658 1.70312 120.042L0 113.231H39.3828Z",
    fill: "url(#paint11_linear_2895_3042)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.157 156.393H27.8753L27.8411 156.21C27.1146 152.336 24.9882 148.888 21.9023 146.502H167.237L159.157 156.393Z",
    fill: "url(#paint12_linear_2895_3042)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.375 97.9454H143.871V99.7438H139.375V97.9454Z",
    fill: "#AFC4E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.955 97.9456H165.451V99.7439H160.955V97.9456Z",
    fill: "#AFC4E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.568 97.9456H151.064V99.7439H146.568V97.9456Z",
    fill: "#AFC4E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M153.762 97.9456H158.258V99.7439H153.762V97.9456Z",
    fill: "#AFC4E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M139.375 103.341H143.871V105.139H139.375V103.341Z",
    fill: "#AFC4E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M160.955 103.341H165.451V105.139H160.955V103.341Z",
    fill: "#AFC4E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.568 103.341H151.064V105.139H146.568V103.341Z",
    fill: "#AFC4E8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.762 103.341H158.258V105.139H153.762V103.341Z",
    fill: "#AFC4E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.706 144.703H19.1957C17.5369 143.612 15.9672 142.409 14.4951 141.107H171.644L168.706 144.703Z",
    fill: "url(#paint13_linear_2895_3042)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.537 71.8689H26.616L28.7741 113.232H23.3789L25.537 71.8689Z",
    fill: "url(#paint14_linear_2895_3042)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2861 83.1089L26.0764 82.6593L36.8668 83.1089V84.0081L26.0764 84.4577L15.2861 84.0081V83.1089Z",
    fill: "url(#paint15_linear_2895_3042)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09277 117.278C8.09277 116.533 8.69665 115.929 9.44156 115.929H17.5343C18.2792 115.929 18.8831 116.533 18.8831 117.278C18.8831 118.023 18.2792 118.627 17.5343 118.627H9.44156C8.69665 118.627 8.09277 118.023 8.09277 117.278Z",
    fill: "url(#paint16_linear_2895_3042)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M148.367 117.278C148.367 116.533 148.971 115.929 149.716 115.929H157.809C158.554 115.929 159.157 116.533 159.157 117.278C159.157 118.023 158.554 118.627 157.809 118.627H149.716C148.971 118.627 148.367 118.023 148.367 117.278Z",
    fill: "url(#paint17_linear_2895_3042)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4717 117.278C31.4717 116.533 32.0756 115.929 32.8205 115.929H40.9132C41.6581 115.929 42.262 116.533 42.262 117.278C42.262 118.023 41.6581 118.627 40.9132 118.627H32.8205C32.0756 118.627 31.4717 118.023 31.4717 117.278Z",
    fill: "url(#paint18_linear_2895_3042)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2895_3042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 134,
    width: 33,
    height: 22
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M145 134V139.958V156H159.322L175.5 136C175.5 134.255 175.316 137.771 177.084 134H145Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2895_3042)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_g_2895_3042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.798 154.595C224.798 173.962 209.097 189.663 189.73 189.663C170.362 189.663 154.661 173.962 154.661 154.595C154.661 135.227 170.362 119.526 189.73 119.526C209.097 119.526 224.798 135.227 224.798 154.595Z",
    fill: "#A6BCE2",
    fillOpacity: 0.4
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M204.4 0C210.254 0.000211602 215 4.77609 215 10.667V77C191.252 77 172 96.2518 172 120C172 122.734 172.258 125.408 172.746 128H119.6C113.746 128 109 123.224 109 117.333V10.667C109 4.77609 113.746 0.000212639 119.6 0H204.4Z",
    fill: "url(#paint19_linear_2895_3042)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M125 32.2C125 29.3281 127.328 27 130.2 27H145.8C148.672 27 151 29.3281 151 32.2V47.8C151 50.6719 148.672 53 145.8 53H130.2C127.328 53 125 50.6719 125 47.8V32.2Z",
    fill: "url(#paint20_linear_2895_3042)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M157 32C157 29.2386 159.351 27 162.25 27H193.75C196.649 27 199 29.2386 199 32V32C199 34.7614 196.649 37 193.75 37H162.25C159.351 37 157 34.7614 157 32V32Z",
    fill: "url(#paint21_linear_2895_3042)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M125 66.5C125 63.4624 127.366 61 130.286 61H193.714C196.634 61 199 63.4624 199 66.5V66.5C199 69.5376 196.634 72 193.714 72H130.286C127.366 72 125 69.5376 125 66.5V66.5Z",
    fill: "url(#paint22_linear_2895_3042)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M157 48C157 45.2386 159.328 43 162.2 43H177.8C180.672 43 183 45.2386 183 48C183 50.7614 180.672 53 177.8 53H162.2C159.328 53 157 50.7614 157 48Z",
    fill: "url(#paint23_linear_2895_3042)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M193.714 80C194.901 80 195.998 80.37 196.88 80.9951C192.113 83.2132 187.823 86.2799 184.199 90H130.286C127.367 90 125 87.7614 125 85C125 82.2386 127.367 80 130.286 80H193.714Z",
    fill: "#3E83FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M178.05 98C176.025 101.393 174.454 105.087 173.422 109H130.286C127.367 109 125 106.538 125 103.5C125 100.462 127.367 98 130.286 98H178.05Z",
    fill: "#3E83FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M252 120.056C252 140.46 235.46 157 215.056 157C194.653 157 178.112 140.46 178.112 120.056C178.112 99.6528 194.653 83.1125 215.056 83.1125C235.46 83.1125 252 99.6528 252 120.056Z",
    fill: "#196BFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M250.003 120.056C250.003 100.756 234.357 85.1094 215.056 85.1094C195.755 85.1094 180.109 100.756 180.109 120.056C180.109 139.357 195.755 155.003 215.056 155.003V157C194.653 157 178.112 140.46 178.112 120.056C178.112 99.6528 194.653 83.1125 215.056 83.1125C235.46 83.1125 252 99.6528 252 120.056C252 140.46 235.46 157 215.056 157V155.003C234.357 155.003 250.003 139.357 250.003 120.056Z",
    fill: "url(#paint24_linear_2895_3042)",
    fillOpacity: 0.4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2895_3042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.006 120.056C248.006 101.859 233.253 87.1065 215.056 87.1065C196.858 87.1065 182.106 101.859 182.106 120.056C182.106 138.254 196.858 153.006 215.056 153.006V154.005C196.307 154.005 181.107 138.805 181.107 120.056C181.107 101.307 196.307 86.108 215.056 86.108C233.805 86.108 249.004 101.307 249.004 120.056C249.004 138.805 233.805 154.005 215.056 154.005V153.006C233.253 153.006 248.006 138.254 248.006 120.056Z",
    fill: "url(#paint25_linear_2895_3042)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2895_3042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.01 120.056C245.01 103.513 231.599 90.1019 215.056 90.1019C198.512 90.1019 185.101 103.513 185.101 120.056C185.101 136.6 198.512 150.011 215.056 150.011V154.005C196.307 154.005 181.107 138.805 181.107 120.056C181.107 101.307 196.307 86.108 215.056 86.108C233.805 86.108 249.004 101.307 249.004 120.056C249.004 138.805 233.805 154.005 215.056 154.005V150.011C231.599 150.011 245.01 136.6 245.01 120.056Z",
    fill: "url(#paint26_linear_2895_3042)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2895_3042",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 83,
    width: 74,
    height: 74
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M252 120.056C252 140.46 235.46 157 215.056 157C194.653 157 178.112 140.46 178.112 120.056C178.112 99.6528 194.653 83.1125 215.056 83.1125C235.46 83.1125 252 99.6528 252 120.056Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2895_3042)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_g_2895_3042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.042 106.078C224.042 119.312 213.313 130.041 200.079 130.041C186.844 130.041 176.115 119.312 176.115 106.078C176.115 92.8428 186.844 82.114 200.079 82.114C213.313 82.114 224.042 92.8428 224.042 106.078Z",
    fill: "url(#paint27_linear_2895_3042)",
    fillOpacity: 0.4
  })))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M247.007 120.056C247.007 102.41 232.702 88.1049 215.056 88.1049C197.409 88.1049 183.104 102.41 183.104 120.056C183.104 137.703 197.409 152.008 215.056 152.008V154.005C196.307 154.005 181.107 138.805 181.107 120.056C181.107 101.307 196.307 86.108 215.056 86.108C233.805 86.108 249.004 101.307 249.004 120.056C249.004 138.805 233.805 154.005 215.056 154.005V152.008C232.702 152.008 247.007 137.703 247.007 120.056Z",
    fill: "url(#paint28_linear_2895_3042)",
    fillOpacity: 0.8
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2895_3042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.638 107.245C229.889 104.819 233.68 104.677 236.105 106.928C238.53 109.178 238.672 112.969 236.422 115.394L215.504 137.934C213.928 139.633 211.241 139.638 209.659 137.944L193.705 120.872C191.446 118.455 191.574 114.664 193.991 112.405C196.409 110.146 200.2 110.274 202.459 112.691L211.092 121.929C211.883 122.776 213.226 122.774 214.014 121.924L227.638 107.245Z",
    fill: "#2B62C7"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M227.638 107.245C229.889 104.819 233.68 104.677 236.105 106.928C238.53 109.178 238.672 112.969 236.422 115.394L215.504 137.934C213.928 139.633 211.241 139.638 209.659 137.944L193.705 120.872C191.446 118.455 191.574 114.664 193.991 112.405C196.409 110.146 200.2 110.274 202.459 112.691L211.092 121.929C211.883 122.776 213.226 122.774 214.014 121.924L227.638 107.245Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M226.175 105.887C229.176 102.653 234.23 102.464 237.464 105.464L237.758 105.751C240.611 108.681 240.784 113.31 238.158 116.445L237.886 116.753L216.969 139.293C214.604 141.841 210.574 141.848 208.201 139.308L192.246 122.236C189.234 119.013 189.406 113.958 192.629 110.946C195.852 107.934 200.906 108.105 203.918 111.329L212.551 120.566L226.175 105.887ZM234.747 108.392C233.13 106.892 230.603 106.986 229.102 108.603L215.479 123.283C213.902 124.982 211.215 124.986 209.633 123.293L201.001 114.055C199.495 112.443 196.967 112.358 195.355 113.864C193.743 115.37 193.658 117.898 195.164 119.509L211.118 136.581C211.909 137.428 213.253 137.426 214.041 136.576L234.959 114.036C236.412 112.47 236.369 110.049 234.894 108.535L234.747 108.392Z",
    fill: "url(#paint29_linear_2895_3042)",
    fillOpacity: 0.54
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M226.174 105.887C226.925 105.078 228.188 105.031 228.996 105.781C229.805 106.532 229.852 107.795 229.102 108.603L215.478 123.283C213.901 124.982 211.215 124.987 209.632 123.294L201 114.055C200.247 113.249 200.29 111.986 201.095 111.233C201.901 110.48 203.164 110.523 203.917 111.329L212.551 120.566L226.174 105.887Z",
    fill: "url(#paint30_linear_2895_3042)",
    fillOpacity: 0.44
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M192.629 110.946C195.852 107.934 200.906 108.105 203.918 111.328L212.551 120.566C213.304 121.372 213.262 122.636 212.456 123.389C211.65 124.142 210.386 124.099 209.633 123.293L201.001 114.055C199.495 112.443 196.967 112.357 195.355 113.863C193.743 115.37 193.658 117.898 195.164 119.509L211.118 136.581C211.871 137.387 211.828 138.651 211.022 139.404C210.217 140.156 208.954 140.114 208.201 139.308L192.246 122.235C189.234 119.012 189.406 113.958 192.629 110.946Z",
    fill: "url(#paint31_linear_2895_3042)",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_g_2895_3042",
    x: 131.461,
    y: 96.3261,
    width: 116.537,
    height: 116.537,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6666666269302368 1.6666666269302368",
    numOctaves: 3,
    seed: 9013
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 46.400001525878906,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2895_3042"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2895_3042",
    x: 177.107,
    y: 82.108,
    width: 75.8965,
    height: 75.8966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2895_3042"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2895_3042",
    x: 177.107,
    y: 82.108,
    width: 75.8965,
    height: 75.8966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2895_3042"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_g_2895_3042",
    x: 129.015,
    y: 35.014,
    width: 142.127,
    height: 142.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "5 5",
    numOctaves: 3,
    seed: 5929
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 94.19999694824219,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage",
    width: "100%",
    height: "100%"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2895_3042"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2895_3042",
    x: 178.491,
    y: 91.7286,
    width: 73.1297,
    height: 61.0828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.8,
    result: "effect1_foregroundBlur_2895_3042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2895_3042",
    x1: 70.0054,
    y1: 113,
    x2: 70.0054,
    y2: 125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2895_3042",
    x1: 70.0054,
    y1: 119.462,
    x2: 70.0054,
    y2: 125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2895_3042",
    x1: 70,
    y1: 102,
    x2: 70,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2895_3042",
    x1: 70,
    y1: 109.192,
    x2: 70,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2895_3042",
    x1: 81.5,
    y1: 90,
    x2: 81.5,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2895_3042",
    x1: 81.5,
    y1: 98.3077,
    x2: 81.5,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2895_3042",
    x1: 59.3465,
    y1: 113.231,
    x2: 59.3465,
    y2: 124.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24447E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2895_3042",
    x1: 82.7254,
    y1: 113.231,
    x2: 82.7254,
    y2: 124.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24447E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2895_3042",
    x1: 59.3465,
    y1: 102,
    x2: 59.3465,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24447E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2895_3042",
    x1: 82.7254,
    y1: 102,
    x2: 82.7254,
    y2: 113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24447E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2895_3042",
    x1: 82.7254,
    y1: 90.0002,
    x2: 82.7254,
    y2: 102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24447E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2895_3042",
    x1: 93.9656,
    y1: 113.232,
    x2: 93.9656,
    y2: 156.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254808,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682692,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2895_3042",
    x1: 94.5696,
    y1: 156.393,
    x2: 94.5696,
    y2: 146.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F95BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#AEC4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9DBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2895_3042",
    x1: 171.644,
    y1: 142.919,
    x2: 14.4951,
    y2: 142.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2895_3042",
    x1: 26.0765,
    y1: 71.8689,
    x2: 26.0765,
    y2: 113.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD2FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2895_3042",
    x1: 26.0764,
    y1: 82.6593,
    x2: 26.0764,
    y2: 84.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2895_3042",
    x1: 18.8831,
    y1: 117.289,
    x2: 8.09277,
    y2: 117.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2895_3042",
    x1: 159.157,
    y1: 117.289,
    x2: 148.367,
    y2: 117.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2895_3042",
    x1: 42.262,
    y1: 117.289,
    x2: 31.4717,
    y2: 117.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2895_3042",
    x1: 162,
    y1: 0,
    x2: 162,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504808,
    stopColor: "#E1ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2895_3042",
    x1: 138,
    y1: 27,
    x2: 138,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2895_3042",
    x1: 178,
    y1: 27,
    x2: 178,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2895_3042",
    x1: 162,
    y1: 61,
    x2: 162,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2895_3042",
    x1: 170,
    y1: 43,
    x2: 170,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413462,
    stopColor: "#639BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2895_3042",
    x1: 191.043,
    y1: 90.963,
    x2: 234.913,
    y2: 153.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#196BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E825AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2895_3042",
    x1: 195.329,
    y1: 91.1543,
    x2: 237.076,
    y2: 149.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456731,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2895_3042",
    x1: 195.329,
    y1: 91.1543,
    x2: 237.076,
    y2: 149.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.586538,
    stopColor: "#1157D5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1157D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2895_3042",
    x1: 200.079,
    y1: 82.114,
    x2: 200.079,
    y2: 130.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2895_3042",
    x1: 192.989,
    y1: 94.1707,
    x2: 236.698,
    y2: 147.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.100962,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2895_3042",
    x1: 210.064,
    y1: 108.075,
    x2: 232.53,
    y2: 130.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A428C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A428C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2895_3042",
    x1: 212.559,
    y1: 107.076,
    x2: 222.045,
    y2: 123.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49263,
    stopColor: "#005BFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#196BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2895_3042",
    x1: 210.563,
    y1: 124.549,
    x2: 200.079,
    y2: 133.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A428C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A428C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneShip);
export default __webpack_public_path__ + "static/media/doneShip.7d4ac68715054d3a7b58120350881954.svg";
export { ForwardRef as ReactComponent };